import { combineReducers } from 'redux';
import { authReducer } from './modules/auth/store/reducer';
import { chatReducer } from './modules/chat/store/reducer';
import { taskReducer } from './modules/task/store/reducer';
import { usersReducer } from './modules/users/store/reducer';
import { sitesReducer } from './modules/sites/store/reducer';
import { siteGroupReducer } from './modules/siteGroup/store/reducer';
import { propConfigReducer } from './modules/propConfig/store/reducer';
import { commonReducer } from './modules/common/store/reducer';
import { taskNotificationReducer } from './modules/taskNotification/store/reducer';
import toastReducer from './utils/toastReducer';
import uiReducer from './utils/uiReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  chat: chatReducer,
  task: taskReducer,
  user: usersReducer,
  sites: sitesReducer,
  sitegroup: siteGroupReducer,
  propconfig: propConfigReducer,
  tasknotification: taskNotificationReducer,
  common: commonReducer,
  toast: toastReducer,
  ui : uiReducer,
  // Add other reducers here
});

export default rootReducer;
